var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsBoolean, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, MaxLength, } from 'class-validator';
import { Difficulty } from '../enums/difficulty.enum.js';
import { MAX_EXERCISE_DEVICE_TEXT_LENGTH } from './create-exercise.dto.js';
export class UpdateExerciseDto {
    id;
    duration;
    title;
    text;
    indication;
    deviceText;
    weightNeeded;
    difficulty;
    exercisePackageIds;
    bodyRegionIds;
}
__decorate([
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateExerciseDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], UpdateExerciseDto.prototype, "duration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateExerciseDto.prototype, "title", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateExerciseDto.prototype, "text", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateExerciseDto.prototype, "indication", void 0);
__decorate([
    IsString(),
    IsOptional(),
    MaxLength(MAX_EXERCISE_DEVICE_TEXT_LENGTH),
    __metadata("design:type", Object)
], UpdateExerciseDto.prototype, "deviceText", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateExerciseDto.prototype, "weightNeeded", void 0);
__decorate([
    IsEnum(Difficulty),
    IsOptional(),
    __metadata("design:type", String)
], UpdateExerciseDto.prototype, "difficulty", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateExerciseDto.prototype, "exercisePackageIds", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateExerciseDto.prototype, "bodyRegionIds", void 0);
//# sourceMappingURL=update-exercise.dto.js.map